<template>
  <div v-if="src" v-cursor class="author-img" :style="{ 'background-image' : `url(${src})` }"></div>
  <div v-else v-cursor class="author-img" :style="{ 'background-image' : 'url(/assets/img/default-user-avatar.png)' }"></div>
</template>

<script>
  export default {
    props: {
      src: String,
      userProfileUrl: String
    },
    methods: {
      click() {
        window.location.href = this.userProfileUrl;
      }
    }
  }
</script>
